import Panel from "@ui/panel/Panel";
import NormalPanel from "@ui/panel/NormalPanel";
import type { ComponentProps } from "react";
import { createPortal } from "react-dom";
// Keyboard ownership is shared by the underlying Panel and NormalPanel.
const ProviderModal = ({ children }: { children: React.ReactNode }) => {
	return createPortal(
		<div style={{ position: "relative", zIndex: 1000 }} onClick={event => event.stopPropagation()}>
			{children}
		</div>,
		document.body,
	);
};

export default function ProviderPanel(props: ComponentProps<typeof Panel>) {
	return props.decorator === "absolute" ? <ProviderModal><Panel {...props} /></ProviderModal> : <Panel {...props} />;
}

export function ProviderNormalPanel(props: ComponentProps<typeof NormalPanel>) {
	return props.decorator === "absolute" ? <ProviderModal><NormalPanel {...props} /></ProviderModal> : <NormalPanel {...props} />;
}
